import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { parseMessageIsitetvData } from './parseMessageIsitetvData';

const IsiteTvIframe = ({ src, qa }) => {
  const documentUrl = encodeURIComponent(document.URL);
  const newSrc = `${src}&isitetv_player_replace_this_url=${documentUrl}`;

  const [height, setHeight] = useState(0);

  useEffect(() => {
    const receiveMessage = (event) => {
      // event.origin is implemented on page isitetv
      if (event.origin !== 'null') { return; }
      const actualReceivedData = parseMessageIsitetvData(event.data);
      if (typeof actualReceivedData.playerHeight === 'number') {
        setHeight(actualReceivedData.playerHeight);
      }
    };

    window.addEventListener('message', receiveMessage);
    return () => {
      window.removeEventListener('message', receiveMessage);
    };
  }, []);

  return (
    <iframe
      id="isitetv"
      title={newSrc}
      src={newSrc}
      allowFullScreen
      scrolling="no"
      frameBorder="0"
      sandbox="allow-scripts"
      width="100%"
      height={`${height}px`}
      data-qa={qa}
    />
  );
};

IsiteTvIframe.propTypes = {
  src: PropTypes.string.isRequired,
  qa: PropTypes.string
};

IsiteTvIframe.defaultProps = {
  qa: undefined
};

export default IsiteTvIframe;
